import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

type PostStatusToggleProps = {
  status: 'draft' | 'published';
  onChange: (status: 'draft' | 'published') => void;
  disabled?: boolean;
};

export default function PostStatusToggle({ 
  status, 
  onChange,
  disabled 
}: PostStatusToggleProps) {
  const [isLoading, setIsLoading] = useState(false);

  const handleToggle = async () => {
    setIsLoading(true);
    try {
      const newStatus = status === 'draft' ? 'published' : 'draft';
      onChange(newStatus);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      onClick={handleToggle}
      disabled={disabled || isLoading}
      className={`
        inline-flex items-center px-3 py-1.5 rounded-full text-sm
        ${status === 'published' 
          ? 'bg-green-100 text-green-800 hover:bg-green-200' 
          : 'bg-gray-100 text-gray-800 hover:bg-gray-200'
        }
        ${disabled || isLoading ? 'opacity-50 cursor-not-allowed' : ''}
      `}
    >
      {status === 'published' ? (
        <>
          <Eye className="w-4 h-4 mr-1" />
          已发布
        </>
      ) : (
        <>
          <EyeOff className="w-4 h-4 mr-1" />
          草稿
        </>
      )}
    </button>
  );
}